import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import BackTop from '@/components/base/BackTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import { Link } from 'react-router-dom';

const values = [
  { icon: 'ri-user-heart-line', title: '同好出发', desc: '由一群真心喜欢《师兄啊师兄》的同好共创，一切整理皆源于热爱。' },
  { icon: 'ri-focus-3-line', title: '考据为本', desc: '以正片剧情为唯一依据，逐集梳理人物关系与细节，不无中生有。' },
  { icon: 'ri-leaf-line', title: '理性嗑糖', desc: '尊重原作与每一位角色，开心磕糖、不拉踩、不引战。' },
  { icon: 'ri-refresh-line', title: '持续更新', desc: '随剧集节奏持续补充图谱与名场面，让追更指南永不过期。' },
];

const quotes = [
  {
    text: '把灵秀这条线的时间线捋得明明白白，追更时再也不怕漏糖了。',
    who: '一位灵秀粉',
  },
  {
    text: '酒玖师叔的名场面盘点太对味了，每一条都忍不住回去二刷。',
    who: '叔侄向爱好者',
  },
  {
    text: '人物关系图谱很清晰，对刚入坑的我帮助特别大。',
    who: '新入坑道友',
  },
];

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于师兄啊师兄考据站',
  url: 'https://smetech.com.cn/about',
  description: '关于本站的品牌介绍、定位、发展理念、内容原则与联系方式。',
  inLanguage: 'zh-CN',
  mainEntity: {
    '@type': 'Organization',
    name: '师兄啊师兄考据站',
    email: 'hello@shixiong.fan',
    description: '专注于师兄啊师兄人物关系考据、CP线脉络与师门日常整理的同好内容站。',
  },
};

export default function About() {
  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }} />
      <Header />
      <main className="mx-auto w-full max-w-5xl px-4 py-10 md:px-6 md:py-14">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />

        <header className="rounded-xl bg-background-100/70 p-6 md:p-10">
          <span className="font-seal text-2xl text-primary-600">关于本站</span>
          <h1 className="mt-3 font-heading text-3xl font-black tracking-wide text-foreground-950 md:text-4xl">
            一峰之人，皆是牵挂
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            师兄啊师兄考据站，是一个专注于《师兄啊师兄》的同人内容站。我们用心整理人物关系、CP 线发展脉络与
            师门日常高甜片段，希望为同样喜欢这部动画的你，提供一份能安心追更、慢慢嗑糖的指南。
          </p>
        </header>

        <section aria-label="定位与理念" className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950">我们的定位</h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
              我们相信，一部好作品值得被更认真、更细致地对待。这里的每一份关系图谱、每一次名场面盘点，
              都是基于正片逐集梳理的成果，力求准确、清晰、有温度。无论你是刚入坑的新道友，还是已经二刷的老观众，
              都能在这里找到自己需要的那一份「追更指南」。
            </p>
            <h2 className="mt-8 font-heading text-2xl font-bold text-foreground-950">发展理念</h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
              我们坚持「同好出发、考据为本、理性嗑糖、持续更新」四大理念。尊重原作，尊重每一位角色，
              也尊重每一位读者。比起流量，我们更在意内容是否经得起回看，是否能真正帮到同样热爱这部作品的你。
            </p>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {values.map((v) => (
              <div key={v.title} className="rounded-xl border border-background-200/70 bg-background-50 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-600">
                  <i className={v.icon} />
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section aria-label="用户口碑" className="mt-16">
          <h2 className="font-heading text-2xl font-bold text-foreground-950">同好怎么说</h2>
          <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
            {quotes.map((q) => (
              <figure key={q.who} className="flex flex-col rounded-xl border border-background-200/70 bg-background-100/60 p-5">
                <i className="ri-double-quotes-l text-2xl text-accent-500" />
                <blockquote className="mt-2 flex-1 text-sm leading-7 text-foreground-700">{q.text}</blockquote>
                <figcaption className="mt-4 text-sm text-foreground-500">— {q.who}</figcaption>
              </figure>
            ))}
          </div>
        </section>

        <section aria-label="联系方式" className="mt-16 rounded-xl bg-background-100/70 p-6 md:p-8">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
            <div>
              <h2 className="font-heading text-2xl font-bold text-foreground-950">联系与投稿</h2>
              <p className="mt-4 text-sm leading-7 text-foreground-600">
                欢迎来信补充细节、投稿考据、或指正内容。我们珍视每一位同好的声音，也会认真对待每一条建议。
              </p>
              <div className="mt-5 flex flex-col gap-3 text-sm">
                <p className="flex items-center gap-2.5 text-foreground-700">
                  <i className="ri-mail-line text-lg text-primary-600" /> hello@shixiong.fan
                </p>
                <p className="flex items-center gap-2.5 text-foreground-700">
                  <i className="ri-chat-3-line text-lg text-primary-600" /> 关注「师兄啊师兄考据站」同名平台
                </p>
              </div>
            </div>
            <div className="flex flex-col justify-center gap-4 rounded-xl bg-background-50 p-6">
              <p className="font-seal text-2xl text-primary-700">下个更新见</p>
              <p className="text-sm leading-6 text-foreground-600">
                订阅追更提醒，或去人物关系、CP 线专题逛逛，别错过任何一口糖。
              </p>
              <div className="flex flex-col gap-3 sm:flex-row">
                <Link to="/characters" className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600">
                  人物关系图谱
                </Link>
                <Link to="/" className="whitespace-nowrap rounded-md border border-primary-300 px-5 py-3 text-center text-sm font-medium text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50">
                  回到首页
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}